var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCallheader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.974,
    height: 18,
    viewBox: "0 0 17.974 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "callheader",
    transform: "translate(-0.344 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3296",
    "data-name": "Group 3296",
    transform: "translate(0.344 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3295",
    "data-name": "Group 3295",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M14.527,37.495a1.767,1.767,0,0,0-1.281-.588,1.827,1.827,0,0,0-1.3.584l-1.2,1.194c-.1-.053-.2-.1-.292-.152-.136-.068-.265-.133-.375-.2a13.021,13.021,0,0,1-3.12-2.843A7.682,7.682,0,0,1,5.94,33.874c.311-.284.6-.58.879-.864.106-.106.212-.216.318-.322a1.74,1.74,0,0,0,0-2.624L6.1,29.029c-.118-.118-.239-.239-.353-.36-.227-.235-.466-.478-.713-.705a1.794,1.794,0,0,0-1.27-.557,1.857,1.857,0,0,0-1.289.557l-.008.008-1.289,1.3A2.774,2.774,0,0,0,.36,31.034a6.647,6.647,0,0,0,.485,2.813,16.325,16.325,0,0,0,2.9,4.838,17.84,17.84,0,0,0,5.94,4.652,9.255,9.255,0,0,0,3.336.986c.08,0,.163.008.239.008a2.856,2.856,0,0,0,2.187-.94c0-.008.011-.011.015-.019a8.619,8.619,0,0,1,.663-.686c.163-.155.33-.318.493-.489a1.891,1.891,0,0,0,.572-1.312,1.822,1.822,0,0,0-.584-1.3Zm1.357,3.992s0,0,0,0c-.148.159-.3.3-.462.463a9.97,9.97,0,0,0-.732.758,1.827,1.827,0,0,1-1.425.6c-.057,0-.118,0-.174,0a8.222,8.222,0,0,1-2.957-.887,16.84,16.84,0,0,1-5.6-4.383,15.392,15.392,0,0,1-2.729-4.546,5.414,5.414,0,0,1-.425-2.373,1.74,1.74,0,0,1,.523-1.126L3.2,28.7a.862.862,0,0,1,.576-.269.811.811,0,0,1,.553.265l.011.011c.231.216.451.44.682.679.118.121.239.243.36.368l1.035,1.035a.724.724,0,0,1,0,1.175c-.11.11-.216.22-.326.326-.318.326-.622.629-.952.925-.008.008-.015.011-.019.019a.773.773,0,0,0-.2.861l.011.034a8.31,8.31,0,0,0,1.224,2l0,0A13.914,13.914,0,0,0,9.53,39.193a5.175,5.175,0,0,0,.466.254c.136.068.265.133.375.2.015.008.03.019.045.027a.822.822,0,0,0,.375.095.811.811,0,0,0,.576-.262l1.3-1.3a.858.858,0,0,1,.572-.284.772.772,0,0,1,.546.277l.008.008L15.88,40.3A.75.75,0,0,1,15.884,41.487Z",
    transform: "translate(-0.344 -26.33)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M245.38,86.976a5.051,5.051,0,0,1,4.113,4.113.527.527,0,0,0,.522.44.7.7,0,0,0,.09-.008.53.53,0,0,0,.436-.612,6.107,6.107,0,0,0-4.976-4.976.533.533,0,0,0-.612.432A.524.524,0,0,0,245.38,86.976Z",
    transform: "translate(-235.784 -82.707)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M257.585,8.2A10.056,10.056,0,0,0,249.391.008a.529.529,0,1,0-.173,1.044,8.982,8.982,0,0,1,7.323,7.323.527.527,0,0,0,.522.44.7.7,0,0,0,.09-.008A.52.52,0,0,0,257.585,8.2Z",
    transform: "translate(-239.619 0)",
    fill: "#231f20"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallheader);
export default __webpack_public_path__ + "static/media/callheader.6d61710bacb3322df6501a1c03460ab1.svg";
export { ForwardRef as ReactComponent };